import { render, staticRenderFns } from "./DisposeCountTitle.vue?vue&type=template&id=31f67b53&scoped=true"
import script from "./DisposeCountTitle.vue?vue&type=script&lang=js"
export * from "./DisposeCountTitle.vue?vue&type=script&lang=js"
import style0 from "./DisposeCountTitle.vue?vue&type=style&index=0&id=31f67b53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f67b53",
  null
  
)

export default component.exports